import { render, staticRenderFns } from "./shachong.vue?vue&type=template&id=2fb5a462&"
import script from "./shachong.vue?vue&type=script&lang=js&"
export * from "./shachong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports